import {ref} from 'vue'
// import axios from 'axios'
import {BASE_URL} from "@/composables/url_config";
// import {useStore} from "vuex";
import {log} from "@/composables/useLog"
import axios from "axios";
const error = ref(null)


export const getUserMsisdnDetails= async (token,msisdn)=>{
    log("welcome in  getMsisdns from web")
    if(!token){
        alert("No token in getMsisdns")
    }
    try{
         // alert(" token in getMsisdns")
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/api/v1/home/getUserMsisdnDetails'
        log("url="+url)
        const params = {
            msisdn: msisdn,
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getUserMsisdnDetails")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getUserMsisdnDetails")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getUserMsisdnDetails",msisdnDetails:{}}
    }
}

export const getMsisdnsClasses= async (token)=>{
    log("welcome in  getMsisdnsClasses from web")
    log("chemam getMsisdnsClasses cu token"+token)
    if(!token){
        alert("No token in getMsisdnsClasses")
    }
    try{
         // alert(" token in getMsisdns")
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/get_msisdns_classes_api'
        log("url="+url)
        const params = {
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getMsisdnsClasses dupa get_msisdns_classes_api")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getMsisdnsClasses dupa get_msisdns_classes_api")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getUserMsisdnDetails",msisdnDetails:{}}
    }
}
export const getMsisdnsList= async (token, msisdn_class_id=null, msisdn_like="")=>{
    log("welcome in  getMsisdnsList from web")
    log("chemam getMsisdnsList cu token"+token)
    if(!token){
        alert("No token in getMsisdnsList")
    }
    try{
         // alert(" token in getMsisdns")
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/get_msisdns_list_api'
        log("url="+url)
        const params = {
            msisdn_class_id:msisdn_class_id,
            msisdn_like:msisdn_like
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getMsisdnsList dupa get_msisdns_classes_api")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getMsisdnsList dupa get_msisdns_classes_api")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getUserMsisdnDetails",msisdnDetails:{}}
    }
}
export const deleteMsisdnClass= async (token,msisdn_class_id)=>{
    log("welcome in  deleteMsisdnClass from web")
    log("chemam deleteMsisdnClass cu token"+token)
    if(!token){
        alert("No token in deleteMsisdnClass")
    }
    try{
         // alert(" token in getMsisdns")
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/delete_msisdns_classes_api'
        log("url="+url)
        const params = {
            msisdn_class_id:msisdn_class_id
        };
        const result= await axios.delete(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios deleteMsisdnClass dupa delete_msisdns_classes_api")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get deleteMsisdnClass dupa delete_msisdns_classes_api")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la deleteMsisdnClass"}
    }
}
export const getUserMsisdnsStatus= async (token)=>{
    log("welcome in  getUserMsisdnsStatus from web")
    if(!token){
        alert("No token in getMsisdns")
    }
    try{
         // alert(" token in getMsisdns")
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/api/v1/home/getUserMsisdnsStatus'
        log("url="+url)
        // const result= await axios.get(url)
        const result= await axios.get(url,  {headers: headers})
        log("g2")
        log("result.data din axios getUserMsisdnsStatus")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getUserMsisdnsStatus")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getUserMsisdnsStatus",simsList:[]}
    }
}


export const updateMsisdnClass = async (token, updatedData) => {
    log("welcome to updateMsisdnClass from web");
    if (!token) {
        alert("No token provided in updateMsisdnClass");
        return { error: true, message: "No token provided" };
    }
    log(updatedData)
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const url = `${BASE_URL}/home/update_msisdn_class_api`;
        log(`url=${url}`);
        const result = await axios.put(url, updatedData, { headers });
        log("Successfully updated msisdnClass:");
        log(result.data);
        return result.data;
    } catch (err) {
        alert("Error occurred during updateMsisdnClass");
        log(err);
        return { error: true, message: "Error updating msisdnClass", details: err };
    }
};
export const addNewMsisdnClass = async (token, newMsisdnClassData ) => {
    log("welcome to addNewMsisdnClass from web");
    if (!token) {
        alert("No token provided in addNewMsisdnClass");
        return { error: true, message: "No token provided" };
    }
    log(newMsisdnClassData)
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const url = `${BASE_URL}/home/add_new_msisdn_class_api`;
        log(`url=${url}`);
        const result = await axios.post(url, newMsisdnClassData, { headers });
        log("Successfully created msisdnClass:");
        log(result.data);
        return result.data;
    } catch (err) {
        alert("Error occurred during addNewMsisdnClass");
        log(err);
        return { error: true, message: "Error updating msisdnClass", details: err };
    }
};
const useGetMsisdnsAPIs = () => {
    return { error, getMsisdnsClasses, getMsisdnsList, getUserMsisdnDetails, getUserMsisdnsStatus, updateMsisdnClass, deleteMsisdnClass,addNewMsisdnClass  };
}

export default useGetMsisdnsAPIs
